import { z } from 'zod';

import { DocumentSchema } from './document';

export const ActivityDocumentSchema = DocumentSchema.pick({
  id: true,
  name: true,
}).extend({
  isAvailable: z.boolean(),
});

export type ActivityDocument = z.infer<typeof ActivityDocumentSchema>;
